import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, A11y } from "swiper";

import "swiper/swiper-bundle.css";

SwiperCore.use([Navigation, A11y]);

const GastroTreatmentCarousel = ({ heading, treatments = [] }) => {
  if (!treatments || treatments.length === 0) return null;

  return (
    <section className="pt-5 text-center gastro-section">
      <div className="container mx-auto pe-4 ps-lg-5">
        <div className="row mb-3">
          <div className="col-12 my-5">
            <h2 className="section-title text-capitalize mb-5">
              {heading || "Expert Gastro Treatment & Advanced Surgeries"}
            </h2>
          </div>
        </div>

        <div className="gastro-swiper-wrapper relative ps-lg-3">
          <button className="gastro-swiper-prev">
            <i className="fa-solid fa-chevron-left" />
          </button>
          <button className="gastro-swiper-next">
            <i className="fa-solid fa-chevron-right" />
          </button>

          <Swiper
            navigation={{
              prevEl: ".gastro-swiper-prev",
              nextEl: ".gastro-swiper-next",
            }}
            loop
            spaceBetween={20}
            slidesPerView={3}
            breakpoints={{
              992: { slidesPerView: 3 },
              600: { slidesPerView: 1 },
              0: { slidesPerView: 1 },
            }}
            className="gastro-swiper"
          >
            {treatments.map((item, idx) => (
              <SwiperSlide key={idx}>
                <div className="gastro-single-item box-border p-4">
                  {item?.icon && (
                    <div className="gastro-icon-wrapper mb-3">
                      <img
                        src={`${process.env.REACT_APP_WEB_URL}/${item.icon}`}
                        alt={item.title}
                        className="w-10 h-10"
                        width={40}
                        height={40}
                        onError={(e) => {
                          e.currentTarget.closest(".gastro-icon-wrapper").style.display = "none";
                        }}
                      />
                    </div>
                  )}

                  <h3 className="gastro-item-title">{item.title}</h3>
                  <p
                    className="gastro-item-para"
                    data-sal="slide-up"
                    data-sal-duration="300"
                    dangerouslySetInnerHTML={{ __html: item.desc }}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default GastroTreatmentCarousel;
